import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "inline-flex rounded-lg border border-gray-200 bg-gray-100 p-1" }

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { Gauge, History } from 'lucide-vue-next';


export default /*@__PURE__*/_defineComponent({
  __name: 'DataQualityViewSwitch',
  setup(__props) {

const route = useRoute();

const tabs = [
    { routeName: 'DataQuality', labelKey: 'views.dataQuality.viewSwitch.current', icon: Gauge },
    { routeName: 'DataQualityHistory', labelKey: 'views.dataQuality.viewSwitch.history', icon: History },
];

const activeRouteName = computed(() => route.name);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
      return _createVNode(_component_RouterLink, {
        key: tab.routeName,
        to: { name: tab.routeName },
        "aria-current": tab.routeName === activeRouteName.value ? 'page' : undefined,
        class: _normalizeClass([
                'inline-flex items-center gap-x-1.5 rounded-md py-1.5 px-3 text-sm font-medium transition-colors',
                tab.routeName === activeRouteName.value ? 'bg-white text-primary-800 shadow-sm ring-1 ring-gray-200' : 'text-gray-500 hover:text-gray-700',
            ])
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(tab.icon), {
            class: "h-4 w-4",
            "aria-hidden": "true"
          })),
          _createTextVNode(" " + _toDisplayString(_ctx.$t(tab.labelKey)), 1)
        ]),
        _: 2
      }, 1032, ["to", "aria-current", "class"])
    }), 64))
  ]))
}
}

})